export const API_BASE_URL = process.env.REACT_APP_API_URL;


export const CONTACT_US_BASE_URL = `${API_BASE_URL}/api/contact-us/`;
export const ACCOUNT_CREATION_REQUEST_BASE_URL = `${API_BASE_URL}/api/account-creation-request/`;

export const AUTH_BASE_URL = `${API_BASE_URL}/api/auth`;
export const SUPER_ADMIN_BASE_SERVICE = `${API_BASE_URL}/api/superadmin`;
export const CARTOPOUSSE_BASE_URL = `${API_BASE_URL}/api/cartopousse`;
export const HISTORY_BASE_URL = `${API_BASE_URL}/api/history`;
export const SUBSCRIPTION_BASE_URL = `${API_BASE_URL}/api/subscriptions`;

// Audit
export const AUDIT_BASE_URL = `${API_BASE_URL}/api/audits`;

// My Recommendations
export const AUDIT_MY_RECOMMENDATIONS = `${AUDIT_BASE_URL}/my-recommendations/`;


